import classes from '../undermaintenance/UnderMaintenance.module.scss';

const Unauthorized = () => {
  return (
    <div className={`d-flex flex-column align-items-center bg-white`}>
      <div className={`border-bottom border-lightgrey border-2`}>
        <i className='icon icon__logo animate__animated animate__rubberBand'></i>
      </div>
      <div className={`${classes.messageContainer} mt-4`}>
        <p
          className={`${classes.sessionMessage} mt-2 mb-2 text__grey title__bold title__medium`}>
          Dear C360 User,
        </p>
        <p
          className={`${classes.sessionMessage} mt-2 mb-2 text__grey title__bold title__medium`}>
          Oops! It seems like your access hasn't been set up or you don't have permission for this tool.
        </p>
        <p
          className={`${classes.sessionMessage} mt-2 mb-2 text__grey title__bold title__medium`}>
          For any inquiries or further assistance, please do not hesitate to
          reach out to our support team at C360-USIX-d@gene.com.
        </p>
        <p
          className={`${classes.sessionMessage} mt-2 mb-2 text__grey title__bold title__medium`}>
          Thank you for your cooperation.
        </p>
      </div>
    </div>
  );
};

export default Unauthorized;
